import ContractSpecialistDepartment from './ContractSpecialistDepartment';

export default ContractSpecialistDepartment;
